import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ManageWorkersEdit } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useData } from '@hooks/useData';
import { useGetMyAccountWorkerDetail } from '@services/useGetMyAccountWorkerDetail';

export function ManageWorkersEditPage() {
    const { myAccountWorkerDetail } = useData();
    const { request: requestMyAccountWorkerDetail } = useGetMyAccountWorkerDetail();
    const { uuid } = useParams();
    const { t } = useTranslation();

    // fetch worker detail info
    useEffect(() => {
        requestMyAccountWorkerDetail({ uuid: uuid || '' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const translations = {
        title: t('manage-workers-edit-component.metatags.title', { name: myAccountWorkerDetail?.data?.name }),
        description: t('manage-workers-edit-component.metatags.description', {
            name: myAccountWorkerDetail?.data?.name,
        }),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myWorkersEdit.replace(':uuid', `${uuid}`),
        index: false,
    });

    return <ManageWorkersEdit />;
}
